import {
	Component,
	OnInit,
	Input,
	forwardRef,
	ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {
	NgbDateStruct,
	NgbCalendar,
	NgbTimepickerConfig,
	NgbTimeStruct,
} from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';

@Component({
	selector: 'app-form-datetime',
	templateUrl: './form-datetime.component.html',
	styleUrls: ['./form-datetime.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => FormDatetimeComponent),
			multi: true,
		},
	],
	encapsulation: ViewEncapsulation.None,
})
export class FormDatetimeComponent implements OnInit, ControlValueAccessor {
	@Input() labelTitle: string = '';
	@Input() hourPredeter: number = 0;
	@Input() minutePredeter: number = 0;
	@Input() dateCurrent: boolean = false;
	@Input() inactive: boolean = false;

	onChange: (value: dayjs.Dayjs) => void;
	onTouch: any = () => {};

	date_setting: NgbDateStruct;
	time: NgbTimeStruct;
	meridian = true;
	dateTimeReturn: dayjs.Dayjs;

	constructor(
		private calendar: NgbCalendar,
		config: NgbTimepickerConfig,
	) {
		config.spinners = true; //show arrows on control
	}

	ngOnInit(): void {
		if (this.dateCurrent) {
			this.date_setting = this.calendar.getToday();
		}
		this.time = {
			hour: this.hourPredeter,
			minute: this.minutePredeter,
			second: 0,
		};
	}

	// onChange: any = () => {}

	onDateSelection(date) {
		var dateSelect;
		// if (this.validateTime()){
		dateSelect = new Date(
			date.year,
			date.month - 1,
			date.day,
			this.time.hour,
			this.time.minute,
		);
		var f_date = dayjs(dateSelect);
		this.dateTimeReturn = f_date;
		this.onChange(this.dateTimeReturn);
		// }
		// else{
		//   dateSelect = new Date(date.year, (date.month-1),date.day,0, 0);
		//   var f_date = dayjs(dateSelect);
		//   this.dateTimeReturn=f_date;
		//   this.onChange(this.dateTimeReturn);
		// }
		// var dateSelect = new Date(date.year, (date.month-1),date.day,this.time.hour, this.time.minute);
		// var f_date = dayjs(dateSelect);
		// this.dateTimeReturn=f_date;
		// this.onChange(this.dateTimeReturn);
	}

	onTimeSelect(time) {
		var dateSelect;
		if (this.validateDate()) {
			dateSelect = new Date(
				this.date_setting.year,
				this.date_setting.month - 1,
				this.date_setting.day,
				this.time.hour,
				this.time.minute,
			);
			var f_date = dayjs(dateSelect);
			this.dateTimeReturn = f_date;
			this.onChange(this.dateTimeReturn);
		} else {
			dateSelect = new Date(1901, 1, 1, this.time.hour, this.time.minute);
			var f_date = dayjs(dateSelect);
			this.dateTimeReturn = f_date;
			this.onChange(this.dateTimeReturn);
		}
	}

	validateDate() {
		var response: boolean = true;
		if (this.date_setting === undefined || this.date_setting === null) {
			response = false;
		}
		return response;
	}
	// validateTime(){
	//   var response:boolean=true;
	//   if (this.time === undefined || this.time===null )
	//   {
	//     response=false
	//   }
	//   return response;
	// }

	writeValue(value: dayjs.Dayjs): void {
		if (value === null || value === undefined) {
			this.date_setting = null;
			this.time = {
				hour: this.hourPredeter,
				minute: this.minutePredeter,
				second: 0,
			};
		} else {
			var day_ = parseInt(value.format('D'));
			var month_ = parseInt(value.format('M'));
			var year_ = parseInt(value.format('YYYY'));

			this.date_setting = { day: day_, month: month_, year: year_ };
			this.time = {
				hour: value.hour(),
				minute: value.minute(),
				second: value.second(),
			};
		}
	}
	registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	registerOnTouched(fn: any): void {}
	setDisabledState(isDisabled: boolean): void {
		this.inactive = isDisabled;
	}
}
